import { InsightsTypeMap, InsightsDMKMap } from 'typings';

export const insightsTypeMap: InsightsTypeMap = {
  Inspection: 'Inspection',
  RFWI: 'RFWI',
  Incident: 'Incident',
  'Permit to Work': 'PermitToWork',
  Meeting: 'Meeting',
  Defect: 'Defect',
  Action: 'Action',
  Observation: 'Observation',
  Reporting: 'Reporting'
};

// cspell: ignore rfwi, incd, hazardsource, rootcausetype, mandayslost, conductedby, enddate, lostdays, nearmisses, startdate
export const insightsDMKMap: InsightsDMKMap = {
  insp_scheduled_date: 'InspectionScheduledDate',
  insp_assignee: 'InspectionAssignee',
  insp_reinspection_punch: 'InspectionReinspectionPunch',
  rfwi_scope_of_work: 'RFWIScopeOfWork',
  rfwi_proposed_date: 'RFWIProposedDate',
  rfwi_scheduled_date: 'RFWIScheduledDate',
  rfwi_assignee: 'RFWIAssignee',
  rfwi_inspections_punch: 'RFWIInspectionsPunch',
  incd_date: 'IncidentDate',
  incd_type: 'IncidentType',
  incd_hazard: 'IncidentHazard',
  incd_hazardsource: 'IncidentHazardSource',
  incd_rootcausetype: 'IncidentRootCauseType',
  incd_mandayslost: 'IncidentManDaysLost',
  incd_reportable: 'IncidentReportable',
  ptw_start_date: 'PermitToWorkStartDate',
  ptw_end_date: 'PermitToWorkEndDate',
  ptw_company: 'PermitToWorkCompany',
  meet_date: 'MeetingDate',
  meet_conductedby: 'MeetingConductedBy',
  defect_area: 'DefectArea',
  defect_type: 'DefectType',
  defect_target_date: 'DefectTargetDate',
  defect_assignee: 'DefectAssignee',
  action_type: 'ActionType',
  action_risk_level: 'ActionRiskLevel',
  action_cause_type: 'ActionCauseType',
  action_target_date: 'ActionTargetDate',
  action_assignee: 'ActionAssignee',
  obs_category: 'ObservationCategory',
  obs_type: 'ObservationType',
  obs_action_punch: 'ObservationActionPunch',
  obs_source: 'ObservationSource',
  kpi_startdate: 'KPIStartDate',
  kpi_enddate: 'KPIEndDate',
  kpi_report_accident_all: 'KPIReportAccidentAll',
  kpi_manhours_all: 'KPIManHoursAll',
  kpi_manpower_all: 'KPIManPowerAll',
  kpi_nearmisses_all: 'KPINearMissesAll',
  kpi_accident_all: 'KPIAccidentAll',
  kpi_lostdays_all: 'KPILostDaysAll',
  kpi_report_accident_main: 'KPIReportAccidentMain',
  kpi_manhours_main: 'KPIManHoursMain',
  kpi_manpower_main: 'KPIManPowerMain',
  kpi_nearmisses_main: 'KPINearMissesMain',
  kpi_accident_main: 'KPIAccidentMain',
  kpi_lostdays_main: 'KPILostDaysMain',
  kpi_report_accident_sub: 'KPIReportAccidentSub',
  kpi_manhours_sub: 'KPIManHoursSub',
  kpi_manpower_sub: 'KPIManPowerSub',
  kpi_nearmisses_sub: 'KPINearMissesSub',
  kpi_accident_sub: 'KPIAccidentSub',
  kpi_lostdays_sub: 'KPILostDaysSub',
  insp_step_completed: 'InspectionStepCompleted',
  insp_step_closed: 'InspectionStepClosed',
  insp_step_rejected: 'InspectionStepRejected',
  rfwi_step_approved: 'RFWIStepApproved',
  rfwi_step_acknowledged: 'RFWIStepAcknowledged',
  rfwi_step_rejected: 'RFWIStepRejected',
  ptw_step_approve: 'PermitToWorkStepApprove',
  ptw_step_close: 'PermitToWorkStepClose',
  ptw_step_rejected: 'PermitToWorkStepRejected',
  ptw_step_revoked: 'PermitToWorkStepRevoked',
  meet_step_completed: 'MeetingStepCompleted',
  defect_step_confirmed: 'DefectStepConfirmed',
  defect_step_rectified: 'DefectStepRectified',
  defect_step_completed: 'DefectStepCompleted',
  defect_step_closed: 'DefectStepClosed',
  defect_step_reopened: 'DefectStepReopened',
  defect_step_rejected: 'DefectStepRejected',
  action_step_confirmed: 'ActionStepConfirmed',
  action_step_rectified: 'ActionStepRectified',
  action_step_closed: 'ActionStepClosed',
  action_step_reopened: 'ActionStepReopened',
  action_step_rejected: 'ActionStepRejected',
  obs_step_closed: 'ObservationStepClosed'
};
